// Carries locally-stored preferences across the Medlink -> Maximal rename.
//
// The keys are plain localStorage entries (scanner defaults, dashboard filters,
// per-namespace display preferences). Renaming them without this would silently
// reset every user's saved preferences on first load after the deploy.
//
// Runs once at boot and is idempotent: after the sweep no medlink* key remains,
// so subsequent runs do nothing. Can be deleted once the fleet has rolled over.

const LEGACY_PREFIX = 'medlink';
const CURRENT_PREFIX = 'maximal';

// Only these separators are ours; avoids touching an unrelated key that merely
// happens to start with the same letters.
const LEGACY_PATTERN = /^medlink[._]/;

export function migrateLegacyBrandKeys(storage) {
    const store = storage || (typeof window !== 'undefined' ? window.localStorage : null);
    if (!store) return 0;

    let migrated = 0;
    try {
        const legacyKeys = [];
        for (let i = 0; i < store.length; i += 1) {
            const key = store.key(i);
            if (key && LEGACY_PATTERN.test(key)) legacyKeys.push(key);
        }

        legacyKeys.forEach((oldKey) => {
            const newKey = CURRENT_PREFIX + oldKey.slice(LEGACY_PREFIX.length);
            // Never clobber a value already written under the new name.
            if (store.getItem(newKey) === null) {
                store.setItem(newKey, store.getItem(oldKey));
                migrated += 1;
            }
            store.removeItem(oldKey);
        });
    } catch (err) {
        // Storage can be unavailable (private mode, quota, disabled cookies).
        // Losing preferences is acceptable here; blocking app boot is not.
    }
    return migrated;
}

export default migrateLegacyBrandKeys;
